import "./VocaCards.css";

// 폰의 좁은 칸에서 영어 낱말이 글자 중간에 끊기지 않게(buildin / g) 길이에 따라 글자를 줄인다.
export const phoneWordFontSize = (text) => {
  const length = String(text).length;
  if (length >= 9) return "9px";
  if (length >= 7) return "10.5px";
  return undefined;
};

// [원본 복원] 전개발자 구조 유지. 겉모양은 VocaCards.css(ECHO 톤, 2026-10-27). 여기 남은 인라인 값은 크기뿐이다.
// isWord 는 영어 낱말 줄이다(뜻 줄과 글자 굵기 · 크기가 다르다).
const VocaMatchingCard = ({ selectedIndex, word, handleClick, isWord }) => {
  const m = Math.min(window.innerWidth, window.screen.width) <= 768;
  const isSelected = selectedIndex === word.index;
  const isMatched = word.isMatched;
  const className = [
    "voca-tile",
    isWord ? "voca-tile--word" : "voca-tile--meaning",
    isSelected && !isMatched ? "is-selected" : "",
    isMatched ? "is-matched" : "",
  ].join(" ");
  return (
    <div
      key={word.text}
      className={className}
      lang={isWord ? "en" : undefined}
      style={{
        // 데스크톱은 컨테이너 기준(VocaStudyCard 와 같은 이유)
        width: m ? "16vw" : "calc(20% - 10px)",
        minWidth: m ? "56px" : 0,
        height: m ? "70px" : "25vh",
        // overflow:hidden 은 두지 않는다. 좁은 칸에서 단어의 양끝 글자를 깎았다("carelessly"→"relessly").
        padding: m ? "4px" : "12px",
      }}
      onClick={() => {
        if (isMatched) return;
        handleClick(word.index);
      }}
    >
      <div
        style={{
          // 긴 뜻이 카드 밖으로 삐져나와 잘려 보여서(2026-08-23) 카드 안 스크롤을 달았는데,
          // **아이폰 카카오톡 브라우저에서 스크롤 칸을 누르면 스크롤로 받아들여 카드가
          // 안 눌렸다**(2026-09-28 라이트하우스 박주안, 오류 신고 #31). 짧은 영어 카드만
          // 눌리고 긴 뜻 카드는 아무리 눌러도 짝이 안 맞았다.
          // 그래서 스크롤을 없애고, 긴 뜻은 글자를 줄여 세 줄 안에 담는다. 누르는 것은 항상
          // 바깥 카드가 받도록 안쪽은 터치를 받지 않는다.
          pointerEvents: "none",
          fontSize:
            m && isWord
              ? phoneWordFontSize(word.text)
              : String(word.text).length > 12
                ? m ? "10px" : "16px"
                : undefined,
          hyphens: isWord ? "auto" : undefined,
          WebkitHyphens: isWord ? "auto" : undefined,
          lineHeight: 1.25,
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        {word.text}
      </div>
    </div>
  );
};

export default VocaMatchingCard;
